import { useEffect, useState } from "react";
import { DrawerContainer } from "../../../../../../components/Drawer/DrawerContainer";
import { SubstanceInformationDrawer } from "./SubstanceInformationDrawer";


export const CARCINOGENIG_SUBSTANCES_DRAWER_ACTION_VALUES = {
    SUBSTANCE_INFORMATION: 'substance-information',
};

const DrawerManager = ({ open, setOpen, selectedSubstance, translate, onlyVisual }: any) => {
    const [currentTab, setCurrentTab] = useState<number>(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    useEffect(() => {
        if (open) {
            setCurrentTab(0);
        }
    }, [open]);
    
    const DrawerInputManager = () => {
        switch (open) {
           case CARCINOGENIG_SUBSTANCES_DRAWER_ACTION_VALUES.SUBSTANCE_INFORMATION: 
           {
               return (
                   <SubstanceInformationDrawer
                       setOpen={setOpen}
                       selectedSubstance={selectedSubstance}
                       translate={translate}
                       currentTab={currentTab}
                       handleTabChange={handleTabChange}
                       onlyVisual={onlyVisual}
                   />
               );
           }
           default:
                return <></>;
        }
    };

    return (
        <DrawerContainer setOpen={setOpen} open={open} customWidth={700}>
            <DrawerInputManager />
        </DrawerContainer>
    );
};

export default DrawerManager;